module.exports = __webpack_public_path__ + "img/jacket-front-sub-setIn-zipper.fb3c4ea0.png";